import { escapeRegExp, map, split } from 'lodash/fp';
import { Strong } from '@ahmdigital/ui';
import React from 'react';

import { GetItemProps, LocationResult } from '../../../../types';
import { SearchIcon, SearchItem } from './styles';
import uncapFpIterator from '../../../../../../../../../../../utils/uncap-fp-iterator';

type ItemProps = {
  item: LocationResult;
  searchTerm: string;
  value: string;
  index: number;
  getItemProps: GetItemProps;
  highlightedIndex: number;
};

type HighlightMatches = {
  city?: string;
  country: string;
  searchTerm: string;
};

const highlightMatches = ({ city, country, searchTerm }: HighlightMatches) => {
  const concatenatedString = `${country}${city ? ` (${city})` : ''}`;
  const escapedString = escapeRegExp(searchTerm);
  const regex = new RegExp(`(${escapedString})`, 'i');
  const parts = split(regex, concatenatedString);

  return (
    <span>
      {uncapFpIterator(map)(
        (part: string, index: number) => (regex.test(part) ? <Strong key={index}>{part}</Strong> : part),
        parts,
      )}
    </span>
  );
};

const AutoCompleteItem = ({ getItemProps, item, searchTerm, value, index, highlightedIndex }: ItemProps) => (
  <SearchItem {...getItemProps({ index, item, key: value })} isHighlighted={highlightedIndex === index}>
    <SearchIcon name="map-marker" size="medium" />
    {highlightMatches({ city: item.city?.label, country: item.country, searchTerm })}
  </SearchItem>
);

export default AutoCompleteItem;
